/**
 * @ngdoc services
 * @memberof mercury.modules.reports
 * @name StockPosItemLinks
 * @description Data access service for POS Items
 */
angular.module('mercury.modules.stock.positemlink')
.factory('StockPosItemLinks', ["$resource", "settings", function($resource, settings) {
  var StockPosItemLinks = $resource(settings.apiHost + '/r/StockPositemLinks/:id', {id: '@id'});

  function getAllPosItemLinksForItem(posIdentifier) {
    return StockPosItemLinks.query({posIdentifier: posIdentifier}).$promise;
  }

  function savePosItemLink(link) {
    if (link.deleted) {
      return StockPosItemLinks.delete({}, link).$promise;
    } else if (link.id == null) {
      return StockPosItemLinks.save(link).$promise;
    } else {
      return StockPosItemLinks.update(link).$promise;
    }
  }

  return {
    getAllPosItemLinksForItem: getAllPosItemLinksForItem,
    savePosItemLink: savePosItemLink
  };
}]);
